define([
    "./monitoringCarrierTripOverviewModule",
    "./monitoringCarrierTripOverviewController"
], function () {
});